import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { OrderFulfillmentReducedFragmentDoc } from '../fragments/orderFulfillmentReduced.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchOrderFulfillmentsQueryVariables = Types.Exact<{
  query: Types.Scalars['String'];
  start_date?: Types.InputMaybe<Types.Scalars['String']>;
  end_date?: Types.InputMaybe<Types.Scalars['String']>;
  status?: Types.InputMaybe<Types.Scalars['String']>;
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
  types?: Types.InputMaybe<Array<Types.OrderFulfillmentType> | Types.OrderFulfillmentType>;
}>;


export type SearchOrderFulfillmentsQuery = { __typename?: 'Query', searchOrderFulfillments: { __typename?: 'OrderFulfillmentPaginatedResult', total: number, order_fulfillments: Array<{ __typename?: 'OrderFulfillment', id: string, status: Types.OrderFulfillmentStatus, is_billable: boolean, event_id: string, type: string, timestamp: string, authorized_signer_id?: string | null, authorized_signer_name?: string | null, created_by_id: string, created_by_name: string, event: { __typename?: 'Event', id: string, name?: string | null, is_deleted: boolean }, assets: Array<{ __typename?: 'TrackableItem', id: string }>, container_stations: Array<{ __typename?: 'OrderFulfillmentContainerStation', id: string, name: string, returned_sealed: boolean, containers: Array<{ __typename?: 'OrderFulfillmentContainerLocation', container_id: string, container_type_id: number, container_type_name: string, container_type_image?: string | null }>, manual_amounts: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }> }>, single_containers: Array<{ __typename?: 'OrderFulfillmentContainerLocation', container_id: string, container_type_id: number, container_type_name: string, container_type_image?: string | null }>, goodwill: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }>, manual_amounts: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }>, item_location: { __typename?: 'ItemLocation', id: string, name: string }, event_account: { __typename?: 'EventAccount', id: string, name?: string | null, is_billable: boolean, is_deleted: boolean } }> } };


export const SearchOrderFulfillmentsDocument = gql`
    query SearchOrderFulfillments($query: String!, $start_date: String, $end_date: String, $status: String, $skip: Int!, $take: Int!, $types: [OrderFulfillmentType!]) {
  searchOrderFulfillments(
    query: $query
    start_date: $start_date
    end_date: $end_date
    status: $status
    skip: $skip
    take: $take
    types: $types
  ) {
    total
    order_fulfillments {
      ...OrderFulfillmentReduced
    }
  }
}
    ${OrderFulfillmentReducedFragmentDoc}`;

/**
 * __useSearchOrderFulfillmentsQuery__
 *
 * To run a query within a React component, call `useSearchOrderFulfillmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOrderFulfillmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOrderFulfillmentsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      status: // value for 'status'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useSearchOrderFulfillmentsQuery(baseOptions: Apollo.QueryHookOptions<SearchOrderFulfillmentsQuery, SearchOrderFulfillmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOrderFulfillmentsQuery, SearchOrderFulfillmentsQueryVariables>(SearchOrderFulfillmentsDocument, options);
      }
export function useSearchOrderFulfillmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOrderFulfillmentsQuery, SearchOrderFulfillmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOrderFulfillmentsQuery, SearchOrderFulfillmentsQueryVariables>(SearchOrderFulfillmentsDocument, options);
        }
export type SearchOrderFulfillmentsQueryHookResult = ReturnType<typeof useSearchOrderFulfillmentsQuery>;
export type SearchOrderFulfillmentsLazyQueryHookResult = ReturnType<typeof useSearchOrderFulfillmentsLazyQuery>;
export type SearchOrderFulfillmentsQueryResult = Apollo.QueryResult<SearchOrderFulfillmentsQuery, SearchOrderFulfillmentsQueryVariables>;